<template>
  <v-container class="my-8">
    <v-row class="w--100">
      <v-col cols="12" md="8">
        <strong class="mb-2 blue--text fieldset-title">خدمات و محصولات کسب و کار</strong>
      </v-col>
      <v-col cols="12" md="5">
        <v-select
          open-on-click
          label="نوع فعالیت"
          outlined
          persistent-hint
          item-text="displayName"
          item-value="title"
          dense
          required
          return-object
          :menu-props="{
            closeOnClick: true,
            closeOnContentClick: true,
          }"
          v-model="merchantCategoryTypes"
          :items="dropdownItems"
          @change="getCategoriesTreeList"
          hide-details
        />
      </v-col>
      <v-col
        cols="12"
        md="5"
        v-if="activeSelectedItem && activeSelectedItem.activeTreeItem"
      >
        <v-text-field
          label="جستجو"
          outlined
          dense
          type="text"
          required
          v-model="searchTreeList"
          append-icon="mdi-magnify"
          hide-details
        />
      </v-col>
      <v-col
        cols="3"
        md="2"
        v-if="activeSelectedItem && activeSelectedItem.activeTreeItem"
      >
        <v-btn color="error" @click="closeTree ">بستن</v-btn>
      </v-col>
    </v-row>
    <template v-if="activeSelectedItem && activeSelectedItem.activeTreeItem">
      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-card-title>
              <span class="blue--text text--darken-5">{{
               activeSelectedItem && activeSelectedItem.item && activeSelectedItem.item.displayName?activeSelectedItem.item.displayName:''
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-treeview
                :ref="`treeView${activeSelectedItem && activeSelectedItem.item && activeSelectedItem.item.title ? activeSelectedItem.item.title :''}`"
                item-text="name"
                item-key="id"
                item-children="subcategories"
                :items="activeSelectedItem.treeList"
                :search="searchTreeList"
                color="primary"
                transition
                :open.sync="activeSelectedItem.openTreeItem"
                return-object
              >
                <template v-slot:label="props">
                  <div class="treeCheckBox">
                    <v-checkbox
                      v-if="props.item.isLeaf"
                      v-model="activeSelectedItem.activeTreeItem"
                      class="mt-0"
                      hide-details
                      :value="props.item"
                      :label="props.item.name"
                      small
                      dense
                      :ripple="false"
                      @change="selectTree"
                    >
                    </v-checkbox>
                    <span v-else class="f-s-13 text-right">{{
                      props.item.name
                    }}</span>
                  </div>
                </template>
              </v-treeview>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <v-row
      ref="tables"
      class="mt-5"
      v-if="merchantCategoriesListProps.length"
    >
      <v-col cols="12">
        <MerchantCategoryComponentVue
          :items="merchantCategoriesListProps"
          :fields="merchantCategoryFields"
          @removeFromList="removeMerchantCategoriesList"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
const categoryRepository = () => RepoFactory.get('category');
import MerchantCategoryComponentVue from './MerchantCategoryComponent.vue';
const productsRepository = () => RepoFactory.get('products');

export default {
  components:{
      MerchantCategoryComponentVue
  },
  props:{
    isManufacturer:{
      type : Boolean,
      default: null
    },
  categoryIds:{
    type : Array,
    default: []
  },

  },
  data(){
    return{
      merchantCategoriesListProps:[],
      checkbox:false,
      dropdownItems:[],
        merchantCategoryTypes:[],
        merchantCategoryFields: [
        {
          value: 'mainCategoryTitle',
          text: 'نوع فعالیت',
          sortable: false,
        },
        {
          value: 'breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },

        {
          value: 'actions',
          text: 'حذف',
          sortable: false,
        },
      ],
      actvieList: [],
      activeSelectedItem: {
            item: null,
            treeList: [],
            activeTreeItem: [],
            openTreeItem: [],
          },
      searchTreeList: null,
      selectionItems: [],
      activeTreeItem: null,
      form:{
        categoryIds:[],
        categoryTypes:[]
      }
    }
  },
  watch:{
    isManufacturer(){
      this.getSupplierProductCategoryTypes()
      this.merchantCategoriesListProps=[]
    },
    merchantCategoriesListProps(after,before){
      if (this.$store.getters.pagesIsEdit) {
        this.merchantCategoryTypes = after[0].categoryTypeItem
        this.getCategoriesTreeList({title:after[0].categoryTypeItem})
      }
    }
    // "form.categoryIds":function(){
    //   this.$emit('tableInfo',this.form.categoryIds)
    // }
    
  },
  computed:{

    checkIfSelectedTreeNode() {
      return (
        this.selectionItems.length &&
        this.selectionItems.find((el) => el.activeTreeItem.length)
      );
    },
  },
  methods:{
    selectedActivitiesTypes() {
      if (this.form.categoryTypes.length) {
        return this.actvieList.filter((el) =>
          this.form.categoryTypes.includes(el.title)
        );
      } else {
        return [];
      }
    },
    getSupplierProductCategoryTypes(){
       const loader = this.$loading.show()
        productsRepository()
        .getSupplierCategoryProducts(
          this.$store.getters.productBaseUrl,
           {},
           {supplierIsManufacturer :this.isManufacturer})
        .then(({data})=>{
              this.dropdownItems = this.actvieList.filter((el) =>
                data.includes(el.title)
            );

        })
        .catch((err)=>{
          Helper.handleErrors(err, this)
          loader.hide()})
        .finally(()=>{
          loader.hide()
        })
    },
    getCategoryTypeItems() {
      return new Promise((resolve, reject) => {
       
        enumsRepository()
          .getEnum('CategoryTypeItems', this.$store.getters.productBaseUrl)
          .then(({ data }) => {
             this.actvieList = data;
             this.getSupplierProductCategoryTypes()
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
     getCategoriesTreeList(val) {
      const loader = this.$loading.show();
      const param = {};

      param.categoryTypes = val.title
      
      categoryRepository()
        .getCategoriesListBySelection(this.$store.getters.productBaseUrl, param)
        .then((res) => {
          const data = {
            item: val,
            treeList: res.data,
            activeTreeItem: [],
            openTreeItem: res.data,
          };
          this.$set(this.selectionItems, this.selectionItems.length, data);
          this.activeSelectedItem = data;
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getMerchantCategoriesByIds() {
      let lastItem = this.activeSelectedItem.activeTreeItem[this.activeSelectedItem.activeTreeItem.length-1]
      this.activeSelectedItem.activeTreeItem =[]
      this.activeSelectedItem.activeTreeItem.push(lastItem)
      const ids = this.activeSelectedItem.activeTreeItem.map((el) => {
        return el.id;
      });
      if (this.form.categoryIds == undefined || this.form.categoryIds == null) {
        this.form.categoryIds = [];
      }
     
      this.form.categoryIds = ids;
      
      const params = {
        ids: this.form.categoryIds.join(','),
      };
      
      const loader = this.$loading.show()
      categoryRepository()
        .getMerchantCategoriesByIds(this.$store.getters.productBaseUrl, params)
        .then((res) => {
          let ids=[]
          
         this.merchantCategoriesListProps = res.data

          this.activeSelectedItem.activeTreeItem.forEach((el) => {
            if (!this.form.categoryTypes.includes(el.categoryType)) {
              this.form.categoryTypes.push(el.categoryType);
            }
          });
           this.checkbox =true
          this.checkbox =false
          this.$emit('getCategoryIds', this.form.categoryIds)
          loader.hide()
          console.log('f',  this.merchantCategoriesListProps);
        })
        .catch(err=>{
           Helper.handleErrors(err, this)
          loader.hide()
        })
      },
    selectTree(val) {
        if (val && val.length) {
          this.getMerchantCategoriesByIds();
        } 
        else {
          this.merchantCategoriesListProps = [];
          this.form.categoryIds = null;
        }
      },
    deSelectTree() {
        this.selectionItems.forEach((element) => {
          element.activeTreeItem = [];
        });
      },
    removeMerchantCategoriesList(item) {
      // step:1 remove from merchant categories list
      let app = this
      
      let list = []
      app.merchantCategoriesListProps.forEach(
        el => {
          if(el.categoryId != item.categoryId){
            
            list.push(el)
          }
        }
      );
      // app.merchantCategoriesListProps = []
      app.merchantCategoriesListProps = list

      this.form.categoryIds = this.form.categoryIds.filter(
        (el) => el != item.categoryId
      );
      // step:2 remove from selected tree items
      this.activeSelectedItem.activeTreeItem =
        this.activeSelectedItem.activeTreeItem.filter(
          (el) => el.id != item.categoryId
        );
      this.$emit('getCategoryIds', this.form.categoryIds)

      // step:3 remove from categoryTypes if removed merchant
      // category is not exist in categoryTypes
      const categoryTypeTitle = item.categoryTypeTitle;
      if (
        !this.merchantCategoriesListProps.find(
          (el) => el.categoryTypeTitle == categoryTypeTitle
        )
      ) {
        this.form.categoryTypes.splice(
          this.form.categoryTypes.indexOf(categoryTypeTitle),
          1
        );
        // 
        // this.merchantCategoryTypes.splice(
        //   this.form.categoryTypes.indexOf(
        //     (el) => el.title == categoryTypeTitle
        //   ),
        //   1
        // );
      }
    },
    closeTree() {
      this.activeSelectedItem = null;
      (this.activeTreeItem = []), (this.merchantCategoriesList = []);
      this.merchantCategoryTypes = null;
    },
    
  },
  async created(){
    let app = this
    this.getCategoryTypeItems()
    if(this.$store.getters.pagesIsEdit){
      app.activeSelectedItem.activeTreeItem = [{id:app.categoryIds[0]}]
      await app.getMerchantCategoriesByIds()
      app.merchantCategoriesListProps
    }
  }
}
</script>

<style>

</style>
 
